// extracted by mini-css-extract-plugin
export default {"Text":"CloseDayConfirmationModal_Text__5Vyd8"};